import bannerCloseIcon from '@/Assets/images/bannerCloseIcon.svg';
import nftCardImage from '@/Assets/images/phases/Sunset.png';
// import { ADVENTURE_END } from '@/constants/phase';
import { ROUTES } from '@/constants/routes.constants';
import { useTimeDifference } from '@/hooks/useTimeDifference';
import { MouseEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AdventureProgressBanner } from './AdventureProgressBanner';
import './styles.css';
import clsx from 'clsx';

const ProgressBanner = () => {
  const [isRevealed, setRevealed] = useState<boolean>(false);

  useEffect(() => {
    const revealInterval = setTimeout(() => {
      setRevealed(true);
    }, 2000);

    const bannerInterval = setTimeout(() => {
      setRevealed(false);
    }, 12250);

    return () => {
      clearTimeout(bannerInterval);
      clearInterval(revealInterval);
    };
  }, []);

  const handleBannerCloseClick = (e: MouseEvent) => {
    e.preventDefault();
    setRevealed(false);
  };

  // const timeToEnd = useTimeDifference(ADVENTURE_END.getTime(), true);

  // if (
  //   timeToEnd.days > 0 ||
  //   timeToEnd.hours > 0 ||
  //   +timeToEnd.minutes > 0 ||
  //   +timeToEnd.seconds > 0
  // ) {
  //   return (
  //     <AdventureProgressBanner
  //       isRevealed={isRevealed}
  //       handleBannerCloseClick={handleBannerCloseClick}
  //       endsAt={ADVENTURE_END}
  //       timeToEnd={timeToEnd}
  //     />
  //   );
  // }

  return (
    <div className={clsx('progressBanner', isRevealed && 'visible')}>
      <Link to={ROUTES.QUESTS_PAGE_PHASES} className="progressBanner-content">
        <img src={nftCardImage} className="progressBanner-nftCard" alt="" />
        <div>
          <p>
            Take <strong>Sunset Journey</strong> to get{' '}
            <strong>Sunset NFT</strong>
            <br /> <b>3</b> of 4 RetroBridge Phases NFTs
          </p>
          <div className="progressBanner-progress">
            <div className="progressBanner-progress-filled" />
          </div>
        </div>
        <button
          onClick={handleBannerCloseClick}
          className="progressBanner-close"
        >
          <img src={bannerCloseIcon} alt="bannerClose" />
        </button>
      </Link>
    </div>
  );
};

export default ProgressBanner;
